import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueTierList() {
    const router = useAppRouter();
    const route = useRoute();

    const itemId = StringUtils.toNumber(route.params.itemId);
    const canAddNew = ref(false);

    const loadLeagueItem = useCrudActions().executeAction({
        canExecute: () => itemId != null,
        request: () => leagueService.item.get(itemId),
        onSuccess: ({ data }) => void (canAddNew.value = data.season === 2),
        onError: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    onMounted(loadLeagueItem);

    const { list, total, fetchList } = useBaseListView({
        request: leagueService.tier.list,
        paramsBuilder: () => ({ itemId })
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: tier => leagueService.tier.remove(itemId, tier),
            onSuccess: () => fetchList()
        })
    };

    return { itemId, list, total, canAddNew, fetchList, actions };
}
